// Package Imports
import {
  ScheduleOutlined,
  UploadOutlined,
  CalculatorOutlined,
} from '@ant-design/icons';
// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const identifiers = {
  parent: 'allQueryView',
  upload: 'QueryView',
  calculate: 'allQuery',
};

export const RecalcResource: any = {
  name: resourceName.recalc,
  identifier: identifiers.parent,
  options: { label: 'Recalculation', icon: <ScheduleOutlined /> },
  meta: { label: 'Recalculation', icon: <ScheduleOutlined /> },
};

export const RecalcUploadResource: ResourceItem = {
  name: resourceName.recalcUpload,
  identifier: identifiers.upload,
  list: `${resourceName.recalcUpload}`,
  meta: {
    label: 'Upload',
    icon: <UploadOutlined />,
    parent: resourceName.recalc,
  },
};

export const RecalcCalculateResource: ResourceItem = {
  name: resourceName.recalcCalculate,
  identifier: identifiers.calculate,
  list: `${resourceName.recalcCalculate}`,
  meta: {
    label: 'Calculation',
    icon: <CalculatorOutlined />,
    parent: resourceName.recalc,
  },
};
